import React from 'react';
import { utcIso8601 } from '../utils/formatters';

/**
 * Consistent per-widget audit footer: data source / method / model version /
 * feature snapshot / "as of" ISO-8601 UTC timestamp. Replicated across widgets so
 * every surface carries its own provenance trail (the institutional expectation).
 * Only renders the parts it is given — no fabricated fields.
 */
interface ProvenanceFooterProps {
  source: string;
  method?: string;
  modelVersion?: string;
  snapshot?: string;
  /** Data timestamp. Omit only when the widget genuinely has none. */
  asOf?: Date | string | number;
  className?: string;
}

const ProvenanceFooter: React.FC<ProvenanceFooterProps> = ({
  source,
  method,
  modelVersion,
  snapshot,
  asOf,
  className,
}) => {
  const parts: string[] = [`Source: ${source}`];
  if (method) parts.push(method);
  if (modelVersion) parts.push(`Model v${modelVersion}`);
  if (snapshot) parts.push(`Snapshot ${snapshot}`);
  if (asOf != null) parts.push(`As of ${utcIso8601(asOf)}`);
  return (
    <div
      className={`mt-3 border-t border-[color:rgb(var(--c-border-rgb)/0.6)] pt-2 text-[10px] font-mono text-cmd-textDim ${className ?? ''}`}
    >
      {parts.join(' · ')}
    </div>
  );
};

export default ProvenanceFooter;
